import React, { useState, useEffect } from 'react';
import api from '../services/api';

function errorMessage(err) {
  if (err.status === 404) return 'Không tìm thấy bài làm';
  if (err.status === 403) return 'Bạn không có quyền xem bài làm này';
  return err.message || 'Đã có lỗi xảy ra';
}

function groupAnswersByQuestion(answers) {
  const groups = [];
  const byQuestionId = new Map();

  answers.forEach((answer) => {
    if (byQuestionId.has(answer.question_id)) {
      byQuestionId.get(answer.question_id).options.push(answer);
    } else {
      const group = { ...answer, options: [answer] };
      byQuestionId.set(answer.question_id, group);
      groups.push(group);
    }
  });

  return groups;
}

function QuestionnaireSubmissionDetail({ submissionId }) {
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError(null);
    api.getQuestionnaireSubmission(submissionId)
      .then((data) => {
        if (active) setDetail(data);
      })
      .catch((err) => {
        if (active) setError(errorMessage(err));
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => { active = false; };
  }, [submissionId]);

  if (loading) return <p>Loading...</p>;
  if (error) return <div className="error-message">{error}</div>;
  if (!detail) return null;

  const questionGroups = groupAnswersByQuestion(detail.answers || []);

  return (
    <div className="submission-detail">
      <div className="submission-detail-meta">
        <p><strong>Người làm:</strong> {detail.user_full_name || detail.username}</p>
        <p><strong>Bộ câu hỏi:</strong> {detail.questionnaire_name} ({detail.questionnaire_code})</p>
        <p><strong>Hoàn thành:</strong> {detail.is_complete ? 'Có' : 'Chưa'}</p>
        <p><strong>Nộp lúc:</strong> {detail.submitted_at ? new Date(detail.submitted_at).toLocaleString() : '-'}</p>
        <p><strong>Số câu đã trả lời:</strong> {detail.answer_count}</p>
      </div>

      {questionGroups.length === 0 ? (
        <p>Chưa có câu trả lời nào.</p>
      ) : (
        <ol className="question-list">
          {questionGroups.map((group, index) => (
            <li key={group.question_id} className="question-item">
              <div className="question-text">{index + 1}. {group.question_text}</div>
              <div className="answer-value">
                {group.question_type === 'scale' && (
                  <span>Mức độ: {group.scale_value}</span>
                )}
                {(group.question_type === 'single' || group.question_type === 'multi') && (
                  <span>
                    {group.options
                      .map((opt) => opt.option_text)
                      .filter(Boolean)
                      .join(', ') || '-'}
                  </span>
                )}
                {group.text_value && (
                  <div className="answer-free-text">{group.text_value}</div>
                )}
              </div>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}

export default QuestionnaireSubmissionDetail;
